import {SVGProps} from 'react';

const Icon = (props: SVGProps<SVGSVGElement>) => (
    <svg
        fill="none"
        height="16"
        viewBox="0 0 16 16"
        width="16"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <path
            clipRule="evenodd"
            d="M15 8C15 11.866 11.866 15 8 15C4.13401 15 1 11.866 1 8C1 4.13401 4.13401 1 8 1C11.866 1 15 4.13401 15 8ZM8 8.75C8.9665 8.75 9.75 7.9665 9.75 7C9.75 6.0335 8.9665 5.25 8 5.25C7.0335 5.25 6.25 6.0335 6.25 7C6.25 7.9665 7.0335 8.75 8 8.75ZM10.1242 9.11848C10.6654 8.57582 11 7.82699 11 7C11 5.34315 9.65685 4 8 4C6.34315 4 5 5.34315 5 7C5 7.82699 5.33462 8.57582 5.87585 9.11849C4.52193 9.45554 3.19968 10.2031 2.44098 11.7205L3.55902 12.2795C4.39332 10.6109 6.23057 10.125 8 10.125C9.76943 10.125 11.6067 10.6109 12.441 12.2795L13.559 11.7205C12.8003 10.2031 11.4781 9.45553 10.1242 9.11848Z"
            fill="currentColor"
            fillRule="evenodd"
        />
        <circle cx="8" cy="8" r="6.5" stroke="currentColor" />
    </svg>
);

export default Icon;
